import { getRelativeTime } from '@/utils/common'

export class GlobalNotification {
  id = null
  title = ''
  content = ''
  notificationType = null
  priority = 'medium'
  linkUrl = null
  linkText = ''
  read = false
  createdAt = null
  createdByName = null
  active = true
  type = 'global'

  constructor(origin) {
    if (!origin) return
    
    // Handle both global notification data and combined feed format
    const data = origin.data || origin
    
    this.id = data.id || null
    this.title = data.title || ''
    this.content = data.content || ''
    this.notificationType = data.notification_type || 'announcement'
    this.priority = data.priority || 'medium'
    this.linkUrl = data.link_url || null
    this.linkText = data.link_text || ''
    this.read = data.read || false
    this.active = data.active !== false
    // Handle both created_by_name string and created_by object (for backward compatibility)
    if (data.created_by_name) {
      this.createdByName = data.created_by_name
    } else if (data.created_by && typeof data.created_by === 'object') {
      this.createdByName = data.created_by.name || data.created_by.email || 'System'
    } else {
      this.createdByName = 'System'
    }
    this.type = 'global'
    
    // Handle created_at from either the data or the parent object
    const createdAt = origin.created_at || data.created_at
    if (createdAt) {
      try {
        this.createdAt = getRelativeTime(new Date(createdAt)).toLowerCase()
      } catch (error) {
        console.warn('Error parsing created_at date:', createdAt, error)
        this.createdAt = 'recently'
      }
    } else {
      this.createdAt = 'recently'
    }
  }

  getTypeBadgeColor() {
    const colors = {
      news: '#007bff',
      feature_update: '#28a745',
      announcement: '#fd7e14',
      default: '#6c757d'
    }
    return colors[this.notificationType] || colors.default
  }

  getPriorityColor() {
    const colors = {
      urgent: '#dc3545',
      high: '#fd7e14',
      medium: '#ffc107',
      low: '#007bff'
    }
    return colors[this.priority] || colors.medium
  }

  getPriorityIcon() {
    const icons = {
      urgent: '🔴',
      high: '🟠',
      medium: '🟡',
      low: '🔵'
    }
    return icons[this.priority] || icons.medium
  }

  getTypeDisplayName() {
    const names = {
      news: 'News',
      feature_update: 'Feature Update',
      announcement: 'Announcement'
    }
    return names[this.notificationType] || this.notificationType
  }
}
